import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import ScrollToTop from "./components/ScrollToTop.js";
import HandleToasts from "./components/HandleToasts.jsx";

import HomeScreen from "./screens/HomeScreen.jsx";
import OurStoryScreen from "./screens/OurStoryScreen.jsx";
import OurServicesScreen from "./screens/OurServicesScreen.jsx";
import IndustriesScreen from "./screens/IndustriesScreen.jsx";
import BlogScreen from "./screens/BlogScreen.jsx";
import Blog from "./components/Blog.jsx";

import ContactScreen from "./screens/ContactScreen.jsx";
import NotFoundScreen from "./screens/NotFoundScreen.jsx";

const App = () => {
  return (
    <>
      <HandleToasts />
      <Router>
        <ScrollToTop />
        <Switch>
          <Route path="/" component={HomeScreen} exact />
          <Route path="/our-story" component={OurStoryScreen} exact />
          <Route path="/our-services" component={OurServicesScreen} exact />
          <Route path="/industries" component={IndustriesScreen} exact />
          <Route path="/blogs" component={BlogScreen} exact />
          <Route path="/blog/:slug" component={Blog} exact />
          <Route path="/contact" component={ContactScreen} exact />
          <Route path="*" component={NotFoundScreen} />
        </Switch>
      </Router>
    </>
  );
};

export default App;
